// extracted by mini-css-extract-plugin
var _1 = "AttachmentItem-module__animateUploadProgressBarWidth--H4Axp";
var _2 = "AttachmentItem-module__animatedBackground--zHmqb";
var _3 = "AttachmentItem-module__attachment--ioNTD";
var _4 = "AttachmentItem-module__container--stJtb";
var _5 = "AttachmentItem-module__doc--KjQeu";
var _6 = "AttachmentItem-module__docx--zAETn";
var _7 = "AttachmentItem-module__gif--k6Acy";
var _8 = "AttachmentItem-module__icon--ekfx6";
var _9 = "AttachmentItem-module__jpeg--OrDnG";
var _a = "AttachmentItem-module__jpg--E4ZGS";
var _b = "AttachmentItem-module__link--hwZE5";
var _c = "AttachmentItem-module__menu--Z1Kn6";
var _d = "AttachmentItem-module__menuOpen--GVFFl";
var _e = "AttachmentItem-module__name--_wXZF";
var _f = "AttachmentItem-module__pdf--dMrgA";
var _10 = "AttachmentItem-module__png--SKWak";
var _11 = "AttachmentItem-module__ppt--JKac7";
var _12 = "AttachmentItem-module__pptx--lmH_q";
var _13 = "AttachmentItem-module__size--ZbRJ2";
var _14 = "AttachmentItem-module__sketch--qgtkf";
var _15 = "AttachmentItem-module__source--VxQBK";
var _16 = "AttachmentItem-module__svg--zTTTW";
var _17 = "AttachmentItem-module__type--djDYx";
var _18 = "AttachmentItem-module__uploading--yE2Si";
var _19 = "AttachmentItem-module__xls--_e6TX";
var _1a = "AttachmentItem-module__xlsx--OD0pm";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "attachment", _4 as "container", _5 as "doc", _6 as "docx", _7 as "gif", _8 as "icon", _9 as "jpeg", _a as "jpg", _b as "link", _c as "menu", _d as "menuOpen", _e as "name", _f as "pdf", _10 as "png", _11 as "ppt", _12 as "pptx", _13 as "size", _14 as "sketch", _15 as "source", _16 as "svg", _17 as "type", _18 as "uploading", _19 as "xls", _1a as "xlsx" }
